module.exports = __webpack_public_path__ + "img/australia.2f57ae84.png";